import * as types from "../actions/visitorTypes";
import * as actions from "../actions/visitorActions";
import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 
import dayjs from "dayjs"; // Import dayjs


function* fetchVisitorSaga(action) {
  try {
    //console.log(action.payload);
    const { siteId, fromDate, toDate } = action.payload;
    
    // Calculate default "yesterday" and "today" dates
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    
    const formattedFromDate = fromDate
    ? dayjs(fromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss')
    : dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');  // Default to yesterday, 00:00:00
  
      const formattedToDate = toDate
      ? new Date(new Date(toDate).setHours(23, 59, 59, 999)).toISOString().split('T')[0] + ' ' + new Date(new Date(toDate).setHours(23, 59, 59, 999)).toISOString().split('T')[1]
      : today.toISOString().split('T')[0] + ' ' + new Date(today.setHours(23, 59, 59, 999)).toISOString().split('T')[1];  // default to today

    //console.log('Formatted Dates:', formattedFromDate, formattedToDate);

    const params = {
      siteId,
      fromDate: formattedFromDate,
      toDate: formattedToDate
    };

    //console.log('API Request Params:', params);
    const response = yield call(axiosInstance.get, '/visitor/list-by-site', { params });
    
    //console.log('API Response:', response.data);
    yield put(actions.fetchVisitorSuccess(response.data));
  } catch (error) {
    //console.error('Error fetching visitors:', error);
    yield put(actions.fetchVisitorFailure(error.message));
  }
}

//FOR ADDING SITES
function* addVisitorSaga(action) {
    try {
        ////console.log("in viistor saga")
        ////console.log(action.payload)
        // Make the API call to add the sites
        const response = yield call(axiosInstance.post, '/visitor/in', action.payload );
        ////console.log('visitor added successfully:', response.data);
       
        if (response.data) {
            // Dispatch a success action (you can add a success message or other needed data)
            yield put(actions.addVisitorSuccess());

            // Trigger fetching of the visitor list after successfully adding the visitor
            yield put(actions.fetchVisitorRequest());
        } else {
            // If something goes wrong, we can handle failure
            yield put(actions.addVisitorFailure('Failed to add the visitor'));
        } 
    } catch (error) {
        // Log the error and dispatch failure action
        ////console.error('Error while adding visitor:', error);
        yield put(actions.addVisitorFailure(error.message));
    }
}

//FOR UPDATING VISITORS

function* updateVisitorSaga(action) {
    try {
     ////console.log('saga')
     ////console.log(action.payload)
      yield call(axiosInstance.patch, `/visitor/update/${action.payload.id}`, action.payload);
      ////console.log('Updated Visitors:', response.data);
      yield put(actions.updateVisitorSuccess (action.payload));
    } catch (error) {
        ////console.log(error);
      yield put(actions.updateVisitorFailure(error.message));
    }
  }

     //FOR DELETE VISITOR 
function* deleteVisitorsSaga(action) {
    try {
      ////console.log(action.payload);
      const payload = { visitorid: action.payload.id}
    const response = yield call(axiosInstance.post, "/visitor/out", payload);
    ////console.log(response);
    ////console.log(response.data);

    const visitorout = {
      visitorid: action.payload.id,
      timeout: Date.now(),
    }
    
      // Check the response data to determine if the deletion was successful
      if (response.data) {
        // If the response indicates success, dispatch the success action
        yield put(actions.deleteVisitorSuccess(visitorout)); 
        ////console.log("Deleted visitor  ID:", action.payload.id);
      } else {
        // If the deletion was not successful, dispatch failure with the error message
        yield put(actions.deleteVisitorFailure('Failed to delete site'));
      }
    } catch (error) {
      // Handle any errors (e.g., network errors)
      yield put(actions.deleteVisitorFailure(error.message)); 
    }
  }


export default function* watchFetchData()  {
    yield takeEvery(types.FETCH_VISITOR_REQUEST, fetchVisitorSaga);
    yield takeEvery(types.ADD_VISITOR_REQUEST, addVisitorSaga);
    yield takeEvery(types.UPDATE_VISITOR_REQUEST, updateVisitorSaga);
    yield takeEvery(types.DELETE_VISITOR_REQUEST, deleteVisitorsSaga);
}
